import Button from './Button'
import { ButtonProps, ButtonSocialProps, ButtonSocialType } from './types'

export function ButtonSocial({
  children,
  socialType,
  className,
  ...rest
}: ButtonProps & ButtonSocialProps): React.ReactElement {
  return (
    <Button className={generateClassName(socialType, className)} {...rest}>
      {children}
    </Button>
  )
}

function generateClassName(socialType: ButtonSocialType, className = ''): string | undefined {
  const baseClass = `lg:hover:opacity-95 focus:opacity-95 focus:ring-8 ${className} `
  switch (socialType) {
    case 'facebook-white':
      return baseClass.concat(
        'bg-white text-black-light border border-gray-medium-dark lg:disabled:bg-gray-100 lg:focus:ring-gray-light',
      )
    case 'facebook':
      return baseClass.concat(
        'text-white border border-facebookblue bg-facebookblue lg:disabled:bg-facebookblue lg:focus:ring-blue-light ',
      )

    case 'feide':
      return baseClass.concat('bg-feideblue lg:disabled:bg-feideblue lg:focus:ring-blue-light')

    case 'google':
      return baseClass.concat(
        'bg-white text-black-light border border-gray-medium-dark lg:disabled:bg-gray-100 lg:focus:ring-gray-light',
      )

    default:
      return baseClass
  }
}
